import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function Sidebar() {
    const [color, setColor] = useState(1);

    const active = (data) => {
        setColor(data)
        //console.log(color);
    }

    return (
        <aside className='sidebar'>
            <ul className="navbar" style={{ paddingTop: '20px' }}>

                <Link to="/dash">
                    <li className={`${color === 1 ? 'abc' : ''}`} onClick={(e) => active(1)}>
                        <i className="fa-solid fa-house-chimney"></i>Dashboard
                    </li>
                </Link><br />

                <Link to='/plan'>
                    <li className={`${color === 4 ? 'abc' : ''}`} onClick={(e) => active(4)}>
                        <i className="fa-solid fa-arrow-trend-up"></i>Plan
                    </li>
                </Link><br />

                <Link to='/help'>
                    <li className={`${color === 5 ? 'abc' : ''}`} onClick={(e) => active(5)}>
                        <i className="fa-regular fa-circle-question"></i>Help & Support
                    </li>
                </Link><br />


            </ul>

            <ul className="mini-nav" style={{ paddingTop: '20px' }}>

                <Link to="/dash">
                    <li className={`${color === 1 ? 'abc' : ''}`} onClick={(e) => active(1)}>
                        <i className="fa-solid fa-house-chimney"></i>
                    </li>
                </Link><br />

                <Link to='/plan'>
                    <li className={`${color === 4 ? 'abc' : ''}`} onClick={(e) => active(4)}>
                        <i className="fa-solid fa-arrow-trend-up"></i>
                    </li>
                </Link><br />

                <Link to='/help'>
                    <li className={`${color === 5 ? 'abc' : ''}`} onClick={(e) => active(5)}>
                        <i className="fa-regular fa-circle-question"></i>
                    </li>
                </Link><br />
            </ul>
        </aside>
    )
}

export default Sidebar
